export function extractKcal(text: string) {
  const kcalRegex = /(\d+(,\d{1,2})?)\s*[^\d,]*kcal\b/i
  const match = text.match(kcalRegex)
  return match ? match[1].replace(',', '.') : undefined
}
